<template>
  <div style="background: #fff; width: 100%">
    <div class="section">
      <div class="dashboard-wrapper">
        <div class="account__wrapper">
          <h4 class="acc__title">Account Settings</h4>
          <div data-hover="false" data-delay="0" class="acc-mgt-menu-mob w-dropdown">
            <div class="acc-mgt-menu-mobile w-dropdown-toggle">
              <div class="w-icon-dropdown-toggle"></div>
              <div>Referral</div>
            </div>
            <nav class="dropdown-list-3 w-dropdown-list" style="display: none; visibility: hidden; opacity: 0;">
              <a href="#" class="acc_menu-dropdown-item w-dropdown-link">Basic Information</a>
              <a href="#" class="acc_menu-dropdown-item w-dropdown-link">Change Password</a>
              <a href="#" class="acc_menu-dropdown-item w-dropdown-link">Payments</a>
              <a href="#" class="acc_menu-dropdown-item w-dropdown-link">Referrals</a>
            </nav>
          </div>
          <b-card no-body class="no-card" style="width: 100%">
            <b-tabs card class="tabs-menu-5 w-tabs" style="width: 100%; border: none; margin: 0">
              <b-tab title="Basic information" active class="accounts-tab w-inline-block w-tab-link" >
                <b-card-text>
                  <div class="acc-content-wrapper" style="padding: 0">
                    <div class="acc-module-title">
                      <h5 class="acc-module-heading">Personal info</h5>
                      <p class="acc-module-p">Update your photo and personal details here.</p>
                    </div>
                    <div class="acc-form-block w-form">
                      <div class="upload-image">
                        <img loading="lazy" :src="auth.userInfo.customerPicture || 'https://d3e54v103j8qbb.cloudfront.net/plugins/Basic/assets/placeholder.60f9b1840c.svg'" alt="" class="profile-image" v-if="url === ''">
                        <img loading="lazy" :src="url" alt="" class="profile-image" v-else/>

                      </div>
                      <label style="margin-top: -25px;" class="upload__link">
                        <a style="color: #3abe88;" v-if="!loading">Click to edit photo</a>
                        <p style="color: #3abe88;" v-else>Uploading....</p>
                        <p style="color: red" v-if="fileLarge">File size too large... max 5MB</p>

                        <input
                          style="display: none"
                          type="file"
                          class="input-file"
                          id="files3"
                          name="files"
                          @change="uploadFile('files3')"
                          accept="image/*"
                          ref="file"
                        />
                      </label>
                      <form id="email-form" name="email-form" data-name="Email Form" method="get" class="acc-mgt-form" @submit.prevent="updateUser">
                        <div class="form__item"><label for="First-Name" class="form__label">First Name</label>
                          <div class="input"><input type="text" class="form__input w-input" maxlength="256" name="First-Name" data-name="First Name" placeholder="First Name" id="First-Name" required="" v-model="auth.userInfo.customerFirstName" readonly><img loading="lazy" src="../../../public/images/user.svg" alt="" class="form__input-icon"></div>
                        </div>
                        <div class="form__item"><label for="First-Name-2" class="form__label">Last Name</label>
                          <div class="input"><input type="text" class="form__input w-input" maxlength="256" name="Last-Name" data-name="Last Name" placeholder="First Name" id="Last-Name" required="" v-model="auth.userInfo.customerLastName" readonly><img loading="lazy" src="../../../public/images/user.svg" alt="" class="form__input-icon"></div>
                        </div>
                        <div class="form__item"><label for="First-Name-2" class="form__label">Country</label>
                          <div class="input"><input id="field" name="field" data-name="Field" required="" class="form__input w-input" v-model="auth.userInfo.customerCountry" readonly/><img loading="lazy" src="../../../public/images/flag.svg" alt="" class="form__input-icon"></div>
                        </div>
                        <div class="form__item"><label for="First-Name" class="form__label">E-mail Address</label>
                          <div class="input"><input type="email" class="form__input w-input" maxlength="256" name="Email-2" data-name="Email 2" placeholder="name@someone.com" id="Email-2" required="" v-model="auth.userInfo.customerEmail" readonly><img loading="lazy" src="../../../public/images/mail.svg" alt="" class="form__input-icon"></div>
                        </div>
                        <div class="form__item"><label for="field-3" class="form__label">Add a bio</label><textarea id="field-3" v-model="bio" name="field-3" maxlength="5000" data-name="Field 3" placeholder="Enter bio" class="textarea-2 w-input"></textarea></div>

                        <input type="submit" value="Save Changes" data-wait="Please wait..." class="btn__submit w-button" v-if="!showModal">
                        <div v-else class="btn__submit w-button">
                          <b-spinner
                            small
                            style="color: #fff"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="acc-content-wrapper">
                    <div class="acc-module-title">
                      <h5 class="acc-module-heading">Service &amp; Pricing</h5>
                      <p class="acc-module-p">Configure your pricing options</p>
                    </div>
                    <a href="#" class="btn small secondary w-button">Add pricing</a>
                    <div class="rate-card">
                      <div data-current="Tab 1" data-easing="ease" data-duration-in="300" data-duration-out="100" class="tab1_component w-tabs">
                        <div class="tab1_tabs-menu no-scrollbar w-tab-menu">
                          <a @click="plan='basic'"  data-w-tab="Tab 1" class="tab1_tab-link w-inline-block w-tab-link" :class="{'w--current': plan==='basic'}">
                            <div>Basic</div>
                          </a>
                          <a  @click="plan='standard'" data-w-tab="Tab 2" class="tab1_tab-link w-inline-block w-tab-link" :class="{'w--current': plan==='standard'}">
                            <div>Standard</div>
                          </a>
                          <a @click="plan='premium'" data-w-tab="Tab 3" class="tab1_tab-link w-inline-block w-tab-link" :class="{'w--current':plan==='premium'}">
                            <div>Premium</div>
                          </a>
                        </div>
                        <div class="tab1_tabs-content w-tab-content">
                          <div data-w-tab="Tab 1" class="tab1_tab-pane w-tab-pane" :class="{'w--tab-active': plan==='basic'}">
                            <div class="rate-item">
                              <div class="rate-card-wrapper">
                                <div class="w-form">
                                  <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" class="rate-card-form" data-wf-page-id="64cb721a3c7c4a123aa89434" data-wf-element-id="2eb0d4ba-5b8d-32d2-6155-fc6650dcbfed">
                                    <div class="rate-card-description">
                                      <div class="rate-card-heading">
                                        <h5 class="rate-card-title">Basic</h5>
                                      </div>
                                    </div>
                                    <div class="rate-card-form-item"><label for="name" class="rate-card-form-label">What would you like to call your package content?</label><input v-model="basicPackageName" type="text" class="rate-card-form-input w-input" maxlength="256" name="name" data-name="Name" placeholder="" id="name"></div>
                                    <div class="rate-card-form-item"><label for="name-4" class="rate-card-form-label">Give a description to this package</label><textarea  v-model="basicPackageDescription" id="field-3" name="field-3" maxlength="5000" data-name="Field 3" placeholder="Enter description" class="textarea-2 w-input"></textarea></div>
                                    <div class="rate-card-form-item"><label for="name-2" class="rate-card-form-label">Enter your preferred social media content</label>
                                      <ul role="list" class="rate-list" style="width: 100%">
                                        <li style="width: 100%;display: flex;justify-content: space-between;" v-for="(item, index) in basicArr" :key="index" class="rate-list-item">{{item}}<a @click="removeId(item, index, basicArr)"><img src="../../assets/images/Trash.svg"/></a></li>
                                      </ul>

                                      <div class="rate-list-item"><input v-model="basicNewText" type="text" class="rate-card-form-input w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="e.g. 1 Instagram reel" id="name-2"></div>
                                      <a @click="addToBox" class="add-rate-item-btn">+ Add</a>
                                    </div>
                                    <div class="rate-card-form-item"><label for="name-3" class="rate-card-form-label">Price</label><input v-model="basicPackagePrice" type="text" class="rate-card-form-input price w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="" id="name-2"></div>
                                  </form>
                                  <div class="rate-card-cta-group is-horizontal" style="margin-top: 14px">
                                    <button @click="resetInput" class="btn small secondary w-button">Reset</button>
                                    <button v-if="!showModal" @click="saveChanges" class="btn small w-button">Save Changes</button>
                                    <div class="btn" v-else>
                                      <b-spinner
                                          small
                                          style="color: #fff"
                                      />
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div data-w-tab="Tab 2" class="tab1_tab-pane w-tab-pane" :class="{'w--tab-active': plan==='standard'}">
                            <div class="rate-item">
                              <div class="rate-card-wrapper">
                                <div class="w-form">
                                  <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" class="rate-card-form" data-wf-page-id="64cb721a3c7c4a123aa89434" data-wf-element-id="4a73af22-9702-ed8b-6a0b-22823737c5ad">
                                    <div class="rate-card-description">
                                      <div class="rate-card-heading">
                                        <h5 class="rate-card-title">Standard</h5>
                                      </div>
                                    </div>
                                    <div class="rate-card-form-item"><label for="name" class="rate-card-form-label">What would you like to call your package content?</label><input v-model="standardPackageName" type="text" class="rate-card-form-input w-input" maxlength="256" name="name" data-name="Name" placeholder="" id="name"></div>
                                    <div class="rate-card-form-item"><label for="name-4" class="rate-card-form-label">Give a description to this package</label><textarea  v-model="standardPackageDescription" id="field-3" name="field-3" maxlength="5000" data-name="Field 3" placeholder="Enter description" class="textarea-2 w-input"></textarea></div>
                                    <div class="rate-card-form-item"><label for="name-2" class="rate-card-form-label">Enter your preferred social media content</label>
                                      <ul style="width: 100%;" role="list" class="rate-list">
                                        <li style="width: 100%;display: flex;justify-content: space-between; align-items: center;" v-for="(item, index) in standardArr" :key="index" class="rate-list-item">{{item}}<a @click="removeId(item, index, standardArr)"><img src="../../assets/images/Trash.svg"/></a></li>
                                      </ul>
                                      <div class="rate-list-item"><input v-model="standardNewText" type="text" class="rate-card-form-input w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="e.g. 1 Instagram reel" id="name-2"></div>
                                      <a @click="addToBox" class="add-rate-item-btn">+ Add</a>
                                    </div>
                                    <div class="rate-card-form-item"><label for="name-3" class="rate-card-form-label">Price</label><input v-model="standardPackagePrice" type="text" class="rate-card-form-input price w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="" id="name-2"></div>
                                  </form>
                                  <div class="rate-card-cta-group is-horizontal" style="margin-top: 14px">
                                    <button @click="resetInput" class="btn small secondary w-button">Reset</button>
                                    <button v-if="!showModal" @click="saveChanges" class="btn small w-button">Save Changes</button>
                                    <div class="btn" v-else>
                                      <b-spinner
                                          small
                                          style="color: #fff"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div >
                          <div data-w-tab="Tab 3" class="tab1_tab-pane w-tab-pane" :class="{'w--tab-active': plan==='premium'}">
                            <div class="rate-item">
                              <div class="rate-card-wrapper">
                                <div class="w-form">
                                  <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" class="rate-card-form" data-wf-page-id="64cb721a3c7c4a123aa89434" data-wf-element-id="04222e35-199b-2977-fe20-b42a2a2f1a32">
                                    <div class="rate-card-description">
                                      <div class="rate-card-heading">
                                        <h5 class="rate-card-title">Premium</h5>
                                      </div>
                                    </div>
                                    <div class="rate-card-form-item"><label for="name" class="rate-card-form-label">What would you like to call your package content?</label><input v-model="premiumPackageName" type="text" class="rate-card-form-input w-input" maxlength="256" name="name" data-name="Name" placeholder="" id="name"></div>
                                    <div class="rate-card-form-item"><label for="name-4" class="rate-card-form-label">Give a description to this package</label><textarea  v-model="premiumPackageDescription" id="field-3" name="field-3" maxlength="5000" data-name="Field 3" placeholder="Enter description" class="textarea-2 w-input"></textarea></div>
                                    <div class="rate-card-form-item"><label for="name-2" class="rate-card-form-label">Enter your preferred social media content</label>
                                      <ul style="width: 100%;" role="list" class="rate-list">
                                        <li style="width: 100%; display: flex; justify-content: space-between; align-items: center;" v-for="(item, index) in premiumArr" :key="index" class="rate-list-item">{{item}}<a @click="removeId(item, index, premiumArr)"><img src="../../assets/images/Trash.svg"/></a></li>
                                      </ul>
                                      <div class="rate-list-item"><input v-model="premiumNewText" type="text" class="rate-card-form-input w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="e.g. 1 Instagram reel" id="name-2"></div>
                                      <a @click="addToBox" class="add-rate-item-btn">+ Add</a>
                                    </div>
                                    <div class="rate-card-form-item"><label for="name-3" class="rate-card-form-label">Price</label><input v-model="premiumPackagePrice" type="text" class="rate-card-form-input price w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="" id="name-2"></div>
                                  </form>
                                  <div class="rate-card-cta-group is-horizontal" style="margin-top: 14px">
                                    <button @click="resetInput" class="btn small secondary w-button">Reset</button>
                                    <button v-if="!showModal" @click="saveChanges" class="btn small w-button">Save Changes</button>
                                    <div class="btn" v-else>
                                      <b-spinner
                                          small
                                          style="color: #fff"
                                      />
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab title="Change Password" class="accounts-tab w-inline-block w-tab-link">
                <b-card-text>
                  <div class="acc-content-wrapper">
                    <div class="acc-module-title">
                      <h5 class="acc-module-heading">Change Password</h5>
                      <p class="acc-module-p">Update your password details here.</p>
                    </div>
                    <div class="acc-form-block w-form">
                      <form id="email-form" name="email-form" data-name="Email Form" method="get" class="acc-mgt-form" @submit.prevent="changePassword">
                        <div class="form__item"><label for="First-Name-2" class="form__label">Enter Current Password</label>
                          <div class="input"><input type="password" class="form__input w-input" maxlength="6" minlength="6" name="Password" data-name="Password" placeholder="password" id="Password"  required="" v-model="changemodel.oldPassword" @keypress="isNumber"><img loading="lazy" src="../../../public/images/lock.svg" alt="" class="form__input-icon"></div>
                        </div>
                        <div class="form__item"><label for="First-Name-2" class="form__label">Enter New Password</label>
                          <div class="input"><input type="password" class="form__input w-input" maxlength="6" minlength="6" name="Password-3" data-name="Password 3" placeholder="password" id="password" required="" v-model="changemodel.password" @keypress="isNumber"><img loading="lazy" src="../../../public/images/lock.svg" alt="" class="form__input-icon"></div>
                        </div>
                        <div class="form__item"><label for="First-Name-2" class="form__label">Confirm New Password</label>
                          <div class="input"><input type="password" class="form__input w-input" maxlength="6" minlength="6" name="Password-2" data-name="Password 2" placeholder="password" id="confirm_password" required="" v-model="changemodel.passwordConfirmation" @keypress="isNumber" @change="validatePassword"><img loading="lazy" src="../../../public/images/lock.svg" alt="" class="form__input-icon"></div>
                        </div><input type="submit" value="Save Changes" data-wait="Please wait..." class="btn__submit w-button">
                      </form>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab title="Payouts Details" class="accounts-tab w-inline-block w-tab-link">
                <b-card-text>

                  <div class="acc-content-wrapper" style="height: 100vh">
                    <div class="payment-details-top">
                      <div class="acc-module-title">
                        <h5 class="acc-module-heading">Payouts Details</h5>
                        <p class="acc-module-p">Update your payment details here</p>
                      </div>
                      <div style="margin-top: 40px">
                        <a data-w-id="8eb9f9c7-b091-09c4-9cef-4cd65a613085" @click="uploadProfile('.add-payout-detail-modal')" class="link-block-26 w-inline-block">
                          <div class="icon-embed-xxsmall w-embed"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--ic" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"></path>
                          </svg></div>
                        </a>
                      </div>
                    </div>
                    <div class="empty-payment" v-if="accountPayout.accountPayout.data.length <= 0">
                      <div class="empty-image"><img src="../../../public/images/promotion-1_1.svg" loading="lazy"  width="150" height="150" alt="promotion"> </div>
                      <div class="empty-content"> No payout account added</div>
                    </div>

                    <div class="payout-accounts-wrapper" v-else>
                      <div class="payoutaccount" style="width: 100%;" v-for="(account) in accountPayout.accountPayout.data" :key="account.accountId">
                        <div class="payment-details" style="width: 100%;">
                          <div class = "bank">
                              <div class="div-block-234">
                                <div class="icon-embed-xxsmall-copy w-embed"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--ic" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                  <path fill="currentColor" d="M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z"></path>
                                </svg></div>
                              </div>
                          </div>
                          <div class="payout-account-text" style="width: 100%; justify-content: space-between">
                            <div class="account-information">
                              <div class="name">{{account.accountName}}</div>
                              <div class="acc-number">
                                <div>{{account.accountBankName}}</div>
                                <div> {{account.accountNumber}}</div>
                              </div>
                            </div>
                            <div class="default" style="height: 26px" v-if="account.accountStatus === 'ACTIVE'">Default</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
<!--                      <div class="payout-account" v-if="accountPayout.accountPayout.responseCode === '00'">-->
<!--                        <div class="div-block-20">-->
<!--                          <div class="div-block-21">-->
<!--                            <div class="text-block-28">🇳🇬</div>-->
<!--                            <div class="text-block-27">{{accountPayout.accountPayout.accountBankName}}</div>-->
<!--                          </div><label class="radio-button-field w-radio"><input type="radio" id="Nigeria" name="Payout" value="Nigeria" data-name="Payout" class="w-form-formradioinput radio-button-2 w-radio-input"><span class="radio-button-label-2 w-form-label" for="Nigeria">Radio</span></label>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                          <div class="text-block-29">{{accountPayout.accountPayout.accountNumber}}</div>-->
<!--                          <div class="text-block-30">{{accountPayout.accountPayout.accountName}}</div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <!--                    <div class="payout-account">-->
                      <!--                      <div class="div-block-20">-->
                      <!--                        <div class="div-block-21">-->
                      <!--                          <div class="text-block-28">🇬🇭</div>-->
                      <!--                          <div class="text-block-27">Ghana Bank</div>-->
                      <!--                        </div><label class="radio-button-field w-radio"><input type="radio" id="Ghana" name="Payout" value="Ghana" data-name="Payout" class="w-form-formradioinput radio-button-2 w-radio-input"><span class="radio-button-label-2 w-form-label" for="Ghana">Radio</span></label>-->
                      <!--                      </div>-->
                      <!--                      <div>-->
                      <!--                        <div class="text-block-29">0123456789</div>-->
                      <!--                        <div class="text-block-30">OROFIN OLUWASEUN GODWIN</div>-->
                      <!--                      </div>-->
                      <!--                    </div>-->
<!--                      <a id="w-node-_7e0c0319-d0aa-6cc4-19a2-b9ab64424a42-b6b20131" href="#" class="add-new-account-link" @click="uploadProfile('.add-payout-detail-modal')">-->
<!--                        <div class="text-block-31" style="color: #489e85">+ Add new <br>payout account</div>-->
<!--                      </a>-->


                </b-card-text>
              </b-tab>
              <b-tab title="Referrals" class="accounts-tab w-inline-block w-tab-link">
                <b-card-text>
                  <div class="acc-content-wrapper" style="height: 100vh">
                    <div class="referrals-hero"><img src="../../../public/images/Gift-Box-In-Hand.png" loading="lazy" width="160" alt="" class="referral-hero-image"></div>
                    <div class="acc-referrals-title">
                      <h5 class="acc-referrals-h">Invite your friends to Apvertise and earn!</h5>
                      <p class="acc-referrals-p">Copy the link below to earn commission when your family &amp; friends launch campaign on Apvertise</p>
                    </div>
                    <div class="referral-block">
                      <div class="referral-item">
                        <div class="referral_details">
                          <div class="referral-title">Referral Code</div>
                          <div class="referral-link" v-if="auth.userInfo.customerInviteId || inviteId || settings.inviteId.customerInviteId" id="inviteId">{{auth.userInfo.customerInviteId || settings.inviteId.customerInviteId}}</div>
                          <div class="referral-link" v-else>Click to generate</div>
                        </div>
                        <a href="#" class="btn_referral w-inline-block" v-if="auth.userInfo.customerInviteId || inviteId" @click="copy('inviteId')" style="position: relative">
                          <img src="../../../public/images/copy-w.svg" loading="lazy" alt="" class="icon-ref"><div class="copy-card" v-if="show" style="position: absolute; left: 26%; top: -30px; text-align: center; width: 80px; border-radius: 8px; color: black">Copied!</div>
                        </a>
                        <a href="#" class="btn_referral w-inline-block" v-else @click="getText" style="position: relative">
                          <div>Generate code</div><img src="../../../public/images/copy-w.svg" loading="lazy" alt="" class="icon-ref"><div class="copy-card" v-if="show" style="position: absolute; left: 26%; top: -30px; text-align: center; width: 80px; border-radius: 8px; color: black">Your code is been generated!</div>
                        </a>
                      </div>
                      <div class="referral-item">
                        <div class="referral_details">
                          <div class="referral-title">Referral Link</div>
                          <div class="referral-link" v-if="auth.userInfo.customerInviteId || inviteId || settings.inviteId.customerInviteId" id="inviteLink">{{getLink}}</div>
                          <div class="referral-link" v-else>Click to generate</div>
                        </div>
                        <a href="#" class="btn_referral w-inline-block" v-if="auth.userInfo.customerInviteId || inviteId" @click="copy('inviteLink')"  style="position: relative">
                          <img src="../../../public/images/link_1.svg" loading="lazy" alt="" class="icon-ref"><div class="copy-card" v-if="show1" style="position: absolute; left: 26%; top: -30px; text-align: center; width: 80px; border-radius: 8px; color: black">Copied!</div>
                        </a>
                        <a href="#" class="btn_referral w-inline-block" v-else @click="getText">
                          <div>Generate code</div><img src="../../../public/images/copy-w.svg" loading="lazy" alt="" class="icon-ref"><div class="copy-card" v-if="show" style="position: absolute; left: 26%; top: -30px; text-align: center; width: 80px; border-radius: 8px; color: black">Your code is been generated!</div>
                        </a>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab title="Socials" class="accounts-tab w-inline-block w-tab-link">
                <b-card-text>
                  <div class="acc-content-wrapper" style="height: 100vh">
                    <div class="main">
                      <div class="inf__onboarding_content" style="margin-top: 20px">
                        <div class="inf__onboarding_text">
                          <h3 class="inf__onboarding-h">Connect your Social profiles</h3>
                          <p class="inf__onboarding-p">
                            Select your preferred social media platforms
                          </p>
                        </div>
                        <div class="social__group">
                          <div class="social__link">
                            <div class="social">
                              <img
                                src="../../../public/images/instagram.svg"
                                loading="lazy"
                                alt=""
                                class="social__icon"
                              />
                              <div>Instagram</div>
                            </div>
                            <a @click="goToInstagram" class="connect__btn" v-if="!connectedInstagram">Connect</a>
                            <a class="connect__btn" style="background-color: #489e85; color: #FFFFFF" v-else>Connected</a>

                          </div>
                          <div class="social__link">
                            <div class="social">
                              <img
                                src="../../../public/images/twitter1.svg"
                                loading="lazy"
                                alt=""
                                class="social__icon"
                              />
                              <div>Twitter</div>
                            </div>
                            <a @click="goToTwitter" href="#" class="connect__btn" v-if="!connectedTwitter">Connect</a>
                            <a class="connect__btn" style="background-color: #489e85; color: #FFFFFF" v-else>Connected</a>

                          </div>
                          <div class="social__link">
                            <div class="social">
                              <img
                                src="../../../public/images/tiktok.svg"
                                loading="lazy"
                                alt=""
                                class="social__icon"
                              />
                              <div>TikTok</div>
                            </div>
                            <a href="#" @click="goToTikTok"  class="connect__btn" v-if="!connectedTiktok">Connect</a>
                            <a class="connect__btn" style="background-color: #489e85; color: #FFFFFF" v-else>Connected</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
    <div class="qoo-modal add-payout-detail-modal">
      <div style="opacity:1; display: flex" class="select-country" v-if="screen === 'one'">
        <div class="select-country-content">
          <div class="topup-modal-1" style="height: auto; width: auto">
            <h1 class="heading-28" style="margin-bottom: 40px">Select country</h1>


            <a data-w-id="445de229-9148-6f4e-3ea6-e15783437a9d" @click="selectCountry('NG', 'Nigeria')" class="link-block-22 w-inline-block"><img src="../../assets/images/Frame_1.svg" loading="lazy" width="32" alt="" class="image-60">
              <div class="payout-country-text">Nigeria</div>
            </a>
            <a data-w-id="445de229-9148-6f4e-3ea6-e15783437aa1" @click="selectCountry('GH', 'Ghana')" class="link-block-22 w-inline-block"><img src="../../assets/images/ghana-1.svg" loading="lazy" width="32" alt="" class="image-60">
              <div class="payout-country-text">Ghana</div>
            </a>
            <a href="#" class="link-block-22"><img src="../../assets/images/canada-1.svg" loading="lazy" width="32" alt="" class="image-60">
              <div class="payout-country-text">Canada</div>
              <div class="text-block-130-copy">Coming soon</div>
            </a>
            <a data-w-id="445de229-9148-6f4e-3ea6-e15783437aa5" href="#" class="link-block-22 w-inline-block"><img src="../../assets/images/Group_1.svg" loading="lazy" width="32" alt="" class="image-60">
              <div class="payout-country-text">Rwanda</div>
              <div class="text-block-130-copy">Coming soon</div>
            </a>
          </div>
        </div>
        <a data-w-id="445de229-9148-6f4e-3ea6-e15783437aa9" href="#" class="close-topup-modal" @click="close('.add-payout-detail-modal')" style="position: absolute; right: 10px; top: 10px"><img src="../../assets/images/close-modal.svg" loading="lazy" alt=""></a>
      </div>
      <div style="opacity:1; display: flex" class="enter-details-modal-ngn" v-if="screen === 'two'">
        <div class="div-block-240" style="margin-right: auto"><img
          src="../../assets/images/NG.svg" /></div>
        <div class="f-modal-title-wrapper-2">
          <div class="f-sub-heading-regular">Add your NGN account</div>
        </div>
        <div class="w-form" style="margin-top: 12px">
          <form id="email-form-3" name="email-form-3" data-name="Email Form 3" method="get" @submit.prevent="createPayoutAccount" class="w-layout-grid" style="grid-template-columns: 1fr;">
            <div class="f-field-wrapper">
              <div class="div-block-224"><input type="text" style="padding-left: 16px" class="f-field-input-2 w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="Account Name" id="name-2"  v-model="model.accountName"></div>
            </div>
            <div class="f-field-wrapper">
              <div class="div-block-224"><input type="text" style="padding-left: 16px"  class="f-field-input-2 w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="Account Number" id="name-2" v-model="model.accountNumber"></div>
            </div>
            <div class="f-field-wrapper">
              <div class="div-block-224"><select
                v-model="model.accountBankCode"
                required
                id="field-3"
                name="field-3"
                style="padding-left: 16px"
                data-name="Field 3"
                class="f-field-input-2 w-select"
              >
                <option value="">Select Bank</option>
                <option
                  v-for="bank in maintenance.bankListFlw.data"
                  v-bind:key="bank.code"
                  :value="bank.code"
                >
                  {{ bank.name }}
                </option>
              </select></div>
            </div>
            <div class="f-field-wrapper">
              <div class="div-block-225">

                <div class="div-block-226"><input type="text" class="f-field-input-2 w-input" style="padding-left: 16px"  maxlength="6" minlength="6" name="name-2" data-name="Name 2" placeholder="OTP" v-model="model.otp" id="name-2"></div>
                <p v-if="showing">OTP has been sent to your email</p>
                <div class="div-block-527">
                  <b-spinner small style="color: #3abe88"  v-if="auth.authLoading"/>
                  <a
                    v-else-if="timerCount > 0"
                    style="text-decoration: none"
                    href="#"
                    class=""
                  ><div class="text-block-32">Request in {{ timerCount }}</div></a
                  >
                  <a href="#" class="" style="text-decoration: none" v-else @click="sendOtp">
                    <div class="text-block-32">Request OTP</div>
                  </a>
                </div> </div>
            </div>

            <input data-w-id="445de229-9148-6f4e-3ea6-e15783437ac7" class="button w-button" v-if="!accountPayout.accountPayoutLoading" value="Add Payout Account" style="width: 100%; margin-top: 12px" type="submit"/>
            <button v-else class="button w-button" style="width: 100%;">
              <b-spinner small style="color: #ffffff" /> please wait...
            </button>
          </form>
          <div class="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
        <a data-w-id="445de229-9148-6f4e-3ea6-e15783437acf" href="#" @click="close('.add-payout-detail-modal')" class="close-topup-modal" style="position: absolute; right: 10px; top: 10px" ><img src="../../assets/images/close-modal.svg" loading="lazy" alt=""></a>
      </div>
      <div style="opacity:1; display: block" class="enter-details-modal-ghn"  v-if="screen === 'three'">
        <div class="div-block-240"><img src="../../assets/images/GH.svg" loading="lazy" alt=""></div>
        <div class="f-modal-title-wrapper-2">
          <div class="f-sub-heading-regular">Add your GHC account</div>
        </div>
        <div class="f-modal-line"></div>
        <div class="w-form">
          <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="641d9c25aea119eeb6b20131" data-wf-element-id="f5ef85cd-d939-7bd8-e574-c80b19461225">
            <div class="w-layout-grid f-account-input-grid-2">
              <div class="f-field-wrapper"><input type="text" class="f-field-input-2 w-input" maxlength="256" name="Full-name" v-model="model.accountName" data-name="Full name" placeholder="Full name" id="Full-name"></div>
              <div class="f-field-wrapper"><input type="text" class="f-field-input-2 w-input" maxlength="256" name="Full-name-2" v-model="model.accountNumber" data-name="Full Name 2" placeholder="Mobile Money Number" id="Full-name-2"></div>
            </div>
          </form>

        </div>
        <div class="f-modal-line"></div>
        <div class="f-modal-wrapper-right">
          <div class="w-layout-grid f-modal-button-grid">
            <a data-w-id="f5ef85cd-d939-7bd8-e574-c80b19461259" href="#" class="f-button-secondary w-button" @click="close('.add-payout-detail-modal')">Cancel</a>
            <a data-w-id="f5ef85cd-d939-7bd8-e574-c80b1946125b" href="#" class="f-button-primary w-button" v-if="!accountPayout.accountPayoutLoading" @click="createPayoutAccount">Save Bank Details</a>
            <button v-else class="button w-button" style="width: 100%;">
              <b-spinner small style="color: #ffffff" /> please wait...
            </button>
          </div>
        </div>
      </div>
      <div class="cashout-success" v-if="screen === 'four'" style="position: relative; display: flex">
        <div class="lottie-animation-2" data-w-id="d575ea54-a3a2-99b0-d7e6-9be20d5428aa" data-animation-type="lottie" data-src="https://uploads-ssl.webflow.com/62dfacded1d3f8f862adb3ad/62dfacded1d3f80d37adb44d_56421-smooth-success-check-animation.json" data-loop="1" data-direction="1" data-autoplay="1" data-is-ix2-target="0" data-renderer="svg" data-default-duration="2" data-duration="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 750" width="750" height="750" preserveAspectRatio="xMidYMid meet" style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px);"><defs><clipPath id="__lottie_element_2"><rect width="750" height="750" x="0" y="0"></rect></clipPath></defs><g clip-path="url(#__lottie_element_2)"><g transform="matrix(1,0,0,1,105,105)" opacity="1" style="mix-blend-mode: multiply; display: block;"><g opacity="1" transform="matrix(1,0,0,1,270,270)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d=" M-204.97999572753906,124.89900207519531 C-227.197998046875,88.51399993896484 -240,45.75199890136719 -240,0 C-240,-132.54800415039062 -132.54800415039062,-240 0,-240 C49.15399932861328,-240 94.85700225830078,-225.22300720214844 132.9080047607422,-199.8699951171875"></path></g></g><g transform="matrix(0.9945219159126282,0.10452846437692642,-0.10452846437692642,0.9945219159126282,375,371)" opacity="1" style="display: block;"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g transform="matrix(-0.8408700227737427,0,0,0.8408700227737427,375.2917785644531,98.4547119140625)" opacity="1" style="display: block;"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,-0.000006908842351549538,0)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(0.1736481636762619,-0.9848077297210693,0.9848077297210693,0.1736481636762619,-324.986572265625,272.69610595703125)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(-0.9396926164627075,-0.3420201241970062,0.3420201241970062,-0.9396926164627075,-112.86664581298828,640.0985717773438)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(-0.4999999701976776,0.8660253882408142,-0.8660253882408142,-0.4999999701976776,285.78839111328125,495)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(0.7660444378852844,0.6427875757217407,-0.6427875757217407,0.7660444378852844,212.1199188232422,77.205322265625)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(0.7660444378852844,-0.6427876353263855,0.6427876353263855,0.7660444378852844,-212.1199188232422,77.205322265625)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(-0.5,-0.8660253882408142,0.8660253882408142,-0.5,-285.78839111328125,495)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(-0.9396926164627075,0.3420201539993286,-0.3420201539993286,-0.9396926164627075,112.86664581298828,640.0985717773438)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(0.1736481785774231,0.9848077297210693,-0.9848077297210693,0.1736481785774231,324.986572265625,272.69610595703125)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(0,181,7)" stroke-opacity="1" stroke-width="25" d="M0 0"></path></g></g></g></g></svg></div>
        <div class="f-margin-bottom-12">
          <div class="f-sub-heading-regular-2">Successful</div>
        </div>
        <div class="f-margin-bottom-28">
          <div class="f-paragraph-small-2">Your payout account has been added <br>successfully.</div>
        </div>
        <a data-w-id="66695219-1e57-28cb-7f18-023da8490961" class="f-button-primary-3 w-button"  @click="close('.add-payout-detail-modal')">Continue</a>
        <a class="f-modal-close w-inline-block" @click="close('.add-payout-detail-modal')" ></a>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/apvertise-new.css";
import "@/assets/css/normalisenew.css";
import "@/assets/css/webflownew.css";
import {mapState} from "vuex";
import store from "@/store/store";
import AuthRequest from "@/model/request/AuthRequest";
import S3Request from "@/model/request/S3Request";
import AccountPayoutRequest from "@/model/request/AccountPayoutRequest";
import BordelessRequest from "@/model/request/BordelessRequest";
import SocialMediaRequest from "@/model/request/SocialMediaRequest";
import PimCampaignRequest from "@/model/request/PimCampaignRequest";

export default {
  name: "AccountSettings",
  components: {},
  data(){
    return {
      bio: "",
      packagemodel: PimCampaignRequest.prototype.createPackage(),
      loading: false,
      arr:[],
      plan:"basic",
      newText:"",
      basicNewText:'',
      standardNewText:'',
      premiumNewText:'',
      basicPackageName: "",
      basicPackageDescription: "",
      basicPackagePrice: "",
      basicArr: [],
      standardPackageName: "",
      standardPackageDescription: "",
      standardPackagePrice: "",
      standardArr: [],
      premiumPackageName: "",
      premiumPackageDescription: "",
      premiumPackagePrice: "",
      premiumArr: [],
      packageName:"",
      packageDescription:"",
      price:"",
      empty:false,
      show: false,
      show1: false,
      inviteId: "",
      url: "",
      base64: "",
      uploadmodel: S3Request.prototype.uploadBase64(),
      prevRoute: null,
      notCopied: true,
      showModal: false,
      changemodel: new AuthRequest().changePassword(),
      model: new AccountPayoutRequest().create(),
      state: 1,
      handlemodel: new BordelessRequest().createAccount(),
      screen: "one",
      timer: "2:00",
      token: null,
      timerCount: 0,
      country: {
        code: "NG",
        name: "Nigeria",
      },
      fileLarge: false,
      showing:false,
      enrollModel: SocialMediaRequest.enroll,
      twitterModel: SocialMediaRequest.addTwitter,
      tiktokModel: SocialMediaRequest.addTiktok,
      redirectURL: "https://app.apvertise.com/onboarding/complete",
      instagramURL: "https://app.apvertise.com/onboarding/complete",
      tiktokRedirectURL: "https://app.apvertise.com/onboarding/complete",
      twitterSelected: false,
      tiktokSelected: false,
      twitterActive: false,
      tiktokActive: false,
      showAddSocial: false,
      instagramActive: false,
      instagramSelected: false,
    }
  },
  computed:{
    ...mapState(["campaign", "auth", "sbucket", "maintenance", "accountPayout", "settings"]),
    getLink(){
      if (this.auth.userInfo.customerInviteId || this.inviteId !== "") {
        let url = window.__env.app.redirectUrl;
        let id = this.auth.userInfo.customerInviteId || this.settings.inviteId.customerInviteId;
        if (this.auth.userInfo.customerInviteId  || this.settings.inviteId.customerInviteId) {
          return url + "register/" + id;
        }
        else {
          return url + "register/" + this.inviteId;
        }
      }
      else {
        return "Click to generate";
      }
    },
    connectedTiktok(){
      let connect = false;
      this.socialMediaDetails.forEach((social) => {
        if (social.socialMediaDetailsPlatform === "Tiktok"){
          connect = true
        }
      })
      return connect
    },
    connectedTwitter(){
      let connect = false;
      this.socialMediaDetails.forEach((social) => {
        if (social.socialMediaDetailsPlatform === "Twitter"){
          connect = true
        }
      })
      return connect
    },
    connectedInstagram(){
      let connect = false;
      this.socialMediaDetails.forEach((social) => {
        if (social.socialMediaDetailsPlatform === "Instagram"){
          connect = true
        }
      })
      return connect
    },
    generateStateParam() {
      let result = "";
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      for (let i = 0; i < 4; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      this.setLastState(result);
      return result;
    },
    generateChallengeCodeParam() {
      let result = "";
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      for (let i = 0; i < 6; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      this.setLastCodeChallengeCode(result);
      return result;
    },
    twitterLink() {
      return `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=Zl9vZ050MUl5dDB0R1NkWjlMQVQ6MTpjaQ&redirect_uri=${this.redirectURL}&scope=users.read%20tweet.read%20offline.access&state=ST02&code_challenge=ST03s5&code_challenge_method=plain`;
    },
    tiktokLink() {
      return `https://www.tiktok.com/v2/auth/authorize?client_key=awuxk8676d36nim9&response_type=code&scope=user.info.basic&redirect_uri=${this.tiktokRedirectURL}&state=ST02`;
      // return `https://www.tiktok.com/auth/authorize/?client_key=awuxk8676d36nim9&scope=user.info.basic&response_type=code&redirect_uri=https://apvertise.com/&state=generate-a-random-string`
    },
    instagramLink() {
      return `https://www.facebook.com/v16.0/dialog/oauth?client_id=246578654416945&redirect_uri=${this.instagramURL}&state=${this.generateStateParam}&response_type=code&scope=instagram_basic,pages_show_list,instagram_manage_comments,instagram_manage_comments&auth_type=rerequest`;
      // return `https://www.tiktok.com/auth/authorize/?client_key=awuxk8676d36nim9&scope=user.info.basic&response_type=code&redirect_uri=https://apvertise.com/&state=generate-a-random-string`
    },
    basicPackage(){
      let packaging = {
        packageContent: ""
      }
      this.pimPackages.data.forEach((packages) => {
        if (packages.packageType === "BASIC"){
          packaging = packages
        }
      })
      return packaging
    },
    standardPackage(){
      let packaging = {
        packageContent: ""
      }
      this.pimPackages.data.forEach((packages) => {
        if (packages.packageType === "STANDARD"){
          packaging = packages
        }
      })
      return packaging
    },
    premiumPackage(){
      let packaging ={
        packageContent: ""
      }
      this.pimPackages.data.forEach((packages) => {
        if (packages.packageType === "PREMIUM"){
          packaging = packages
        }
      })
      return packaging
    },
    ...mapState({
      authorizeState: (state) => state.socialMedia.authorizeState,
      challengeCode: (state) => state.socialMedia.challengeCode,
      pimPackages: (state) => state.pimCampaign.pimPackages,
      socialMediaDetails: (state) => state.socialMedia.socialMediaDetails
    }),
  },
  methods: {
    removeId(id, index, arr){
      arr.splice(index,1)
      return arr
    },
    async saveChanges(){
      this.showModal = true;
      if(this.plan === "basic"){
        this.packagemodel.packageName = this.basicPackageName;
        this.packagemodel.packageDescription = this.basicPackageDescription;
        this.packagemodel.packagePrice = this.basicPackagePrice;
        this.packagemodel.packageContent = this.basicArr.join()
      }
      else if (this.plan === "standard"){
        this.packagemodel.packageName = this.standardPackageName;
        this.packagemodel.packageDescription = this.standardPackageDescription;
        this.packagemodel.packagePrice = this.standardPackagePrice;
        this.packagemodel.packageContent = this.standardArr.join()
      }
      else{
        this.packagemodel.packageName = this.premiumPackageName;
        this.packagemodel.packageDescription = this.premiumPackageDescription;
        this.packagemodel.packagePrice = this.premiumPackagePrice;
        this.packagemodel.packageContent = this.premiumArr.join()
      }
      this.packagemodel.customerId = this.auth.userInfo.customerId;
      this.packagemodel.packageType = this.plan.toUpperCase();
      await this.$store.dispatch("pimCampaign/createPackage", this.packagemodel ).then(() => {
        this.$store.dispatch("pimCampaign/readPackage", {packageCustomerId: this.auth.userInfo.customerId})
      });
      this.showModal = false;
    },
    async updateUser(){
      this.showModal = true;
      await this.$store.dispatch("settings/updatePicture", {customerId: this.auth.userInfo.customerId, url: this.url, customerBio: this.bio ? this.bio : ""}).then();
      this.showModal = false
    },
    resetInput(){
      this.packageName = ""
      this.packageDescription = ""
      this.price = ""
      this.arr=[]
    },
    fetchBank() {
      this.$store.dispatch("maintenance/bankListFlwApi", {
        country: this.model.accountCountry,
      });
    },
    addToBox(){
      if(this.plan==='basic' && this.basicNewText!==""){
        this.basicArr.push(this.basicNewText)
        this.basicNewText=""
      }
      else if(this.plan==='standard' && this.standardNewText!==""){
        this.standardArr.push(this.standardNewText)
        this.standardNewText=""
      }
      else if(this.plan==='premium' && this.premiumNewText!=="")
      {
        this.premiumArr.push(this.premiumNewText)
        this.premiumNewText=""
      }
      // this.arr.push(this.newText)
      // this.newText=""
    },
    startTimer(duration) {
      let timer = duration,
        minutes,
        seconds;
      setInterval(function () {
        minutes = parseInt((timer / 60).toString(), 10);
        seconds = parseInt((timer % 60).toString(), 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        this.timer = minutes + ":" + seconds;
        if (--timer < 0) {
          timer = duration;
        }
      }, 1000);
    },
    sendOtp() {

      this.$store
        .dispatch("auth/resendOtpInApp", {
          phoneNumber: this.auth.userInfo.customerEmail,
          countryCode: "234",
        })
        .then(() => {
          console.log("Timer...");
          this.timerCount = 120;
          this.showing = true;
          setTimeout(() => {
            this.showing = false
          },5000)
        });

    },
    createPayoutAccount() {
      this.model.accountCustomerId = this.auth.userInfo.customerId;
      this.model.accountCountry = this.country.code;
      this.model.username = this.auth.userInfo.customerEmail;
      this.model.accountBankName = this.maintenance.bankListFlw.data.filter(
        (it) => it.code === this.model.accountBankCode
      )[0].name;
      this.$store
        .dispatch("accountPayout/createAccountPayout", this.model)
        .then((res) => {
          // this.close(".enter-details-modal-nigeria")
          this.$store.dispatch("accountPayout/updateAccountPayout", {
            customerId: this.auth.userInfo.customerId,
          });
          console.log(res)
          if (res.responseCode === "00"){
            this.screen = "four"
          }
          else{
            this.close(".add-payout-detail-modal")
          }
          this.model.otp = "";
          this.timerCount = 0;
          // .then(() => {
          //   this.model.accountCountry =
          //     this.accountPayout.accountPayout.accountCountry;
          //   this.model.accountNumber =
          //     this.accountPayout.accountPayout.accountNumber;
          //   this.model.accountName =
          //     this.accountPayout.accountPayout.accountName;
          //   this.model.accountBankCode =
          //     this.accountPayout.accountPayout.accountBankCode;
          //   this.model.accountBankName =
          //     this.accountPayout.accountPayout.accountBankName;
          //   this.model.accountCustomerId =
          //     this.accountPayout.accountPayout.accountCustomerId;
          // });
        });
    },
    selectCountry(_code, _name) {
      this.country.code = _code;
      this.country.name = _name;
      this.model.accountCountry = _code;
      if (this.country.name === "Nigeria"){
        this.screen = "two";
      }
      else {
        this.screen = "three";

      }
      this.$store.dispatch("maintenance/bankListFlwApi", {
        country: this.model.accountCountry,
      });
    },
    validatePassword() {
      let password = document.getElementById("password");
      let confirm_password = document.getElementById("confirm_password");
      if(password.value !== confirm_password.value) {
        confirm_password.setCustomValidity("Passwords Don't Match");
      } else {
        confirm_password.setCustomValidity('');
      }
    },
    uploadProfile(className) {
      this.screen = "one"
      document.querySelector(className).style.display = "flex";
      setTimeout(() => {
        document.querySelector(className).style.opacity = 1;
      }, 300);
    },
    close(className) {
      document.querySelector(className).style.opacity = 0;
      setTimeout(()=>{
        document.querySelector(className).style.display = "none";

      }, 500)
    },
    uploadFile(id) {
      this.loading = true;
      let input = document.getElementById(id)

      let files = input.files;
      console.log(files)
      this.fileName = files[0].name;
      let size = files[0].size / 1000000;
      console.log(size);
      if (size > 5) {
        this.loading = false;
        this.fileLarge = true;
        setTimeout(() => {
          this.fileLarge = false;
        }, 5000)
        return;
      }
      const reader = new FileReader();
      try {
        reader.onload = (e) => {
          this.base64 = e.target.result;
          this.uploadOfficerImage();
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      } catch (e) {
        this.loading = false;
        console.warn(e.message);
      }
    },
    async uploadOfficerImage() {
      this.showLoader = true;
      this.uploadmodel.username = `${
        this.auth.userInfo.customerFirstName + this.auth.userInfo.customerLastName
      }_${Date.now()}`;
      this.uploadmodel.base64 = this.base64;
      await this.$store.dispatch(
        "sbucket/uploadEncodedFile",
        this.uploadmodel,
        { root: true }
      );
      this.url = this.sbucket.s3bucketResponse.url;
      this.loading = false
      localStorage.setItem("userimage", this.url)
      console.log(this.url)
      this.showLoader = false;
    },
    changePassword() {
      this.changemodel.username = this.auth.userInfo.customerEmail;
      this.$store.dispatch("auth/changePassword", this.changemodel).then(()=>{
        this.changemodel.password = "";
        this.changemodel.oldPassword = "";
        this.changemodel.passwordConfirmation = "";
      });
    },
    isNumber(event) {
      if (!/\d/.test(event.key) && event.key !== ".")
        return event.preventDefault();
    },
    hideShareCampaignModal() {
      this.$refs["share-link-modal"].hide();
    },
    showShareCampaignModal() {
      if (this.campaignBudgetExhausted === "NO") {
        if (this.auth.userInfo.responseCode !== "00") {
          this.$router.push("/logon")
        } else {
          if (this.auth.userInfo.customerId !== this.customerId)
            this.$store
              .dispatch("campaign/getShareLink", {
                shareCampaignId: this.campaignId,
                shareCustomerId: this.auth.userInfo.customerId,
              })
              .then(() => {
                if (this.campaign.shareLink.responseCode === "00")
                  this.showModal = !this.showModal;
              });
          else this.showModal = !this.showModal;
          //this.showModal = !this.showModal
          //this.$refs["share-campaign-modal"].show();
        }
      } else {
        store.commit("updateMessage", {
          type: "error",
          title: "Error",
          body: "Campaign budget is exhausted!",
        });
      }
    },
    async getText() {
      if (this.auth.userInfo.customerInviteId || this.inviteId !== ""){
        let copyText = document.getElementById("email-4");
        let url = window.__env.app.appUrl;
        let id = this.auth.userInfo.customerInviteId || this.settings.inviteId.customerInviteId;

        // Select the text field
        // For mobile devices
        this.inviteId = url + "/register/" + id;
        this.showModal = true;
        // Copy the text inside the text field;
        await navigator.clipboard.writeText(copyText.value);
        // Alert the copied text
        // await swal("Success", "Copied the text:" + copyText.value).then()
        // setTimeout(()=>{
        //   this.notCopied = true
        // }, 5000)
      }
      else {
        this.show = true;
        let resp = await this.$store.dispatch("settings/updateGeneralInvite", {customerId: this.auth.userInfo.customerId});
        this.$store.dispatch("auth/validate", {}, ).then();
        this.show = false
        this.inviteId = resp.customerInviteId;
      }
    },
    async copy(id){
      if (id === "inviteId") {
        this.show = true;
      }
      else {
        this.show1 = true;
      }
      let copyText = document.getElementById(id);
      console.log(copyText.innerHTML)
      await navigator.clipboard.writeText(copyText.innerHTML);
      if (id === "inviteId") {
        setTimeout(() => {
          this.show = false
        }, 1500)
      }
      else {
        setTimeout(() => {
          this.show1 = false
        }, 1500)
      }
      // Select the text field
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      // Copy the text inside the text field;

    },
    setLastState(value) {
      this.$store.commit("socialMedia/updateState", value);
      this.lastStateGenerated = value;
    },
    setLastCodeChallengeCode(value) {
      this.$store.commit("socialMedia/updateChallengeCode", value);
      this.lastStateCodeChallengeGenerated = value;
    },
    goToTwitter(){
      localStorage.setItem("social", "twitter")
      this.twitterActive = true;
      window.location.href = this.twitterLink;
    },
    goToTikTok(){
      localStorage.setItem("social", "tiktok")
      this.tiktokActive = true;
      window.location.href = this.tiktokLink;
    },
    goToInstagram(){
      localStorage.setItem("social", "instagram")
      this.instagramActive = true;
      window.location.href = this.instagramLink;
    }

  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      //immediate: true, // This ensures the watcher is triggered upon creation
    },
    'auth.userInfo.customerId':{
      async handler(){
        this.$store.dispatch("pimCampaign/readRecentCampaign", {customerId: this.auth.userInfo.customerId})
        await this.$store.dispatch("pimCampaign/readPackage", {packageCustomerId: this.auth.userInfo.customerId} )
        this.$store.dispatch("accountPayout/updateAccountPayout", {
          customerId: this.auth.userInfo.customerId,
        })
          .then(() => {
            // this.model.accountCountry =
            //   this.accountPayout.accountPayout.accountCountry;
            // this.model.accountNumber =
            //   this.accountPayout.accountPayout.accountNumber;
            // this.model.accountName = this.accountPayout.accountPayout.accountName;
            // this.model.accountBankCode =
            //   this.accountPayout.accountPayout.accountBankCode;
            // this.model.accountBankName =
            //   this.accountPayout.accountPayout.accountBankName;
            // this.model.accountCustomerId =
            //   this.accountPayout.accountPayout.accountCustomerId;
          });
      },
    },
    basicPackage(){
      if (this.basicPackage.packageName){
        this.basicPackageName = this.basicPackage.packageName;
        this.basicPackageDescription = this.basicPackage.packageDescription;
        this.basicPackagePrice = this.basicPackage.packagePrice;
        if (this.basicPackage.packageContent !== ""){
          this.basicArr = this.basicPackage.packageContent.split(",");
        }
        this.premiumPackageName = this.premiumPackage.packageName;
        this.premiumPackageDescription = this.premiumPackage.packageDescription;
        this.premiumPackagePrice = this.premiumPackage.packagePrice;
        if (this.premiumPackage.packageContent !== ""){
          this.premiumArr = this.premiumPackage.packageContent.split(",");
        }
        this.standardPackageName = this.standardPackage.packageName;
        this.standardPackageDescription = this.standardPackage.packageDescription;
        this.standardPackagePrice = this.standardPackage.packagePrice;
        if (this.standardPackage.packageContent !== ""){
          this.standardArr = this.standardPackage.packageContent.split(",");
        };
      }
    },
    'accountPayout.accountPayoutLoading':{
      handler(){
        // this.model.accountCountry =
        //   this.accountPayout.accountPayout.accountCountry;
        // this.model.accountNumber =
        //   this.accountPayout.accountPayout.accountNumber;
        // this.model.accountName = this.accountPayout.accountPayout.accountName;
        // this.model.accountBankCode =
        //   this.accountPayout.accountPayout.accountBankCode;
        // this.model.accountBankName =
        //   this.accountPayout.accountPayout.accountBankName;
        // this.model.accountCustomerId =
        //   this.accountPayout.accountPayout.accountCustomerId;
      }
    }
  },
  beforeMount() {
    if(this.twitterActive){
      let url = window.location.search;
      const urlParams = new URLSearchParams(url);
      this.twitterModel.code = urlParams.get("code");
      this.twitterModel.code_challenge = 'ST03s5';
      this.$store.dispatch("socialMedia/authorizeTwitter", this.twitterModel);
    }
    if(this.tiktokActive){
      let url = window.location.search;
      const urlParams = new URLSearchParams(url);
      this.tiktokModel.code = urlParams.get("code");
      this.$store.dispatch("socialMedia/authorizeTiktok", this.tiktokModel);
    }
    if(this.instagramActive){
      let url = window.location.search;
      const urlParams = new URLSearchParams(url);
      this.tiktokModel.code = urlParams.get("code");
      this.$store.dispatch("socialMedia/authorizeInstagram", this.tiktokModel);
    }

  },
  mounted(){
    this.bio = this.auth.userInfo.customerBio
    this.basicPackageName = this.basicPackage.packageName;
    this.basicPackageDescription = this.basicPackage.packageDescription;
    this.basicPackagePrice = this.basicPackage.packagePrice;
    if (this.basicPackage.packageContent !== ""){
      this.basicArr = this.basicPackage.packageContent.split(",");
    }
    this.premiumPackageName = this.premiumPackage.packageName;
    this.premiumPackageDescription = this.premiumPackage.packageDescription;
    this.premiumPackagePrice = this.premiumPackage.packagePrice;
    if (this.premiumPackage.packageContent !== ""){
      this.premiumArr = this.premiumPackage.packageContent.split(",");
    }
    this.standardPackageName = this.standardPackage.packageName;
    this.standardPackageDescription = this.standardPackage.packageDescription;
    this.standardPackagePrice = this.standardPackage.packagePrice;
    if (this.standardPackage.packageContent !== ""){
      this.standardArr = this.standardPackage.packageContent.split(",");
    }
    let url = localStorage.getItem("userimage");
    if (url){
      this.url = url
    }
    this.$store.dispatch("socialMedia/readCustomer")
    window.onclick = function(event) {
      if (event.target === document.querySelector(".add-payout-detail-modal")) {
        document.querySelector(".add-payout-detail-modal").style.opacity = 0;
        setTimeout(()=>{
          document.querySelector(".add-payout-detail-modal").style.display = "none";
        }, 500)
      }
    }
    document.querySelector('.no-card').classList.remove('card')
    this.fetchBank()
    this.model.accountCountry = this.accountPayout.accountPayout.accountCountry;
    this.$store.dispatch("pimCampaign/readPackage", {packageCustomerId: this.auth.userInfo.customerId});
    this.model.accountNumber =
      this.accountPayout.accountPayout.accountNumber;
    this.model.accountName = this.accountPayout.accountPayout.accountName;
    this.model.accountBankCode =
      this.accountPayout.accountPayout.accountBankCode  || "";
    this.model.accountBankName =
      this.accountPayout.accountPayout.accountBankName;
    this.model.accountCustomerId =
      this.accountPayout.accountPayout.accountCustomerId;
  }
};
</script>

<style scoped>


@media screen and (max-width: 420px) {
  .referral-item {
    overflow: auto;
  }
}

@media screen and (max-width: 728px){
  .account__wrapper {
    width: auto!important;
  }
}
@media screen and (max-width: 991px){
  .dashboard-wrapper{
    margin-top: 110px!important;

  }
}
@media screen and (max-width: 617px){
  .referral-item{
    flex-direction: column!important;
    grid-row-gap: 8px!important;
    grid-column-gap: 8px!important;
    align-items: flex-start!important;
  }
  .btn_referral{
    align-self: flex-end!important;
  }

}







@media screen and (max-width: 641px){
  .dropdown-list-3.w-dropdown-list{
    display: flex !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

}

.acc-referrals-title{
  width:auto!important;
}


h1,h2,h3,h4,h5,h6,p{
  margin: 0;
}
.section{
  height: 100%;
}
.dashboard-wrapper{
  height: 100%;
  width: 100%;
}
.account__wrapper {
  width: 712px;
  margin-right: auto;
  margin-left: auto;
}
.acc-mgt-menu-mob{
  display: none;
}
.acc-mgt-tabs {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.form__item {
  display: flex;
  flex-direction: column;
  grid-column-gap: 6px;
  grid-row-gap: 6px;
}

.form__label {
  font-family: Figtree, sans-serif;
  color: #344054;
  font-size: 0.875rem;
  line-height: 1.4285714285714286;
  font-weight: 500 !important;
}

.input {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.form__input {
  position: relative;
  height: 44px;
  margin-bottom: auto;
  padding: 10px 14px 10px 48px;
  border-style: solid;
  border-width: 1px;
  border-color: #d0d5dd;
  border-radius: 50rem;
  background-color: #fff;
  font-family: Figtree, sans-serif;
  font-size: 0.875rem;
  line-height: 1.7142857142857142;
  font-weight: 500;
  margin: 0;
}

.form__input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  right: auto;
  height: 20px;
  transform: translate(0px, -50%);
}

.btn__submit {
  display: flex;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #489e85;
  font-family: Figtree, sans-serif;
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  margin-top: 15px;
}

.input-group-25 {
  display: -ms-grid;
  display: grid;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  -ms-grid-columns: 1fr 25%;
  grid-template-columns: 1fr 25%;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

.referrals-hero {
  margin-top: 25px;
  display: flex;
  padding-top: 16px;
  padding-bottom: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background-color: #eaf5f2;
}

.referral-hero-image {
  width: 150px;
  height: auto;
}

.acc-referrals-title {
  display: flex;
  width: 454px;
  margin-right: auto;
  margin-left: auto;
  flex-direction: column;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
}

.acc-referrals-h {
  font-family: Figtree, sans-serif;
  line-height: 1.2;
  font-weight: 700;
  text-align: center;
}

.acc-referrals-p {
  color: #667085;
  text-align: center;
}

.referral-block {
  display: flex;
  flex-direction: column;
  grid-column-gap: 24px;
  grid-row-gap: 24px;
}

.referral-item {
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-color: #d0d5dd;
  border-radius: 16px;
}

.referral_details {
  display: flex;
  flex-direction: column;
  grid-column-gap: 6px;
  grid-row-gap: 6px;
}

.btn_referral:hover {
  background-color: #387b68;
}

.btn_referral {
  display: flex;
  width: 165px;
  padding: 10px 18px;
  justify-content: center;
  align-items: center;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  border-radius: 100px;
  background-color: #489e85;
  transition: all 200ms ease;
  color: #fff !important;
  font-weight: 600;
  text-decoration: none;
  cursor: copy;
}

.referral-title {
  color: #667085;
}

.referral-link {
  color: #344054;
  font-size: 1.0rem;
}

.payout-account {
  height: 134px;
  color: #fff;
  background-color: #101828;
  //background-image: url(../../../public/images/Rectangle.png);
  background-position: 0 0;
  background-size: 339px;
  border-radius: 8px;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 24px;
  text-decoration: none;
  display: flex;
}

.div-block-20 {
  justify-content: space-between;
  align-items: center;
  display: flex;
}


.radio-button-label-2 {
  display: none;
}

.text-block-29 {
  color: #d0d5dd;
  font-size: .875rem;
  font-weight: 300;
}

.text-block-30 {
  color: white;
  font-weight: 500;
}

.div-block-21{
  margin: 0;
}

.div-block-527 {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  display: flex;
}
.field-label-18 {
  color: rgba(2, 4, 9, .68);
  font-weight: 400;
}
.text-block-32 {
  color: #489e85;
  font-size: .875rem;
  font-weight: 500;
  margin: 0
}
.button {
  width: auto;
  color: #fff;
  text-align: center;
  background-color: #489e85;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 1.5rem;
  font-size: .875rem;
  font-weight: 600;
  text-decoration: none;
  display: flex;
}

.button:hover {
  background-color: #387b68;
}
a:active, a:hover {
  outline: 0;
}
.name{
  font-weight: 600;
  color: #000;
  font-size: 1rem;
  line-height: 1.5;
  font-family: Figtree, sans-serif;
}
.acc-number{
  display: flex;
  gap:24px;
  color: #475467;
  font-size: .875rem;
  font-weight: 400;
}
.payout-accounts-wrapper{
  display: flex;
  flex-direction: column;
  gap: 16px;
}


.empty-content{
  font-family: Figtree, sans-serif;
  //font-size: 1rem;
  line-height: 1.5;
  color: #1d2939;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 600;

}
.payment-details-top{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.default{
  color: #387b68;
  background-color: rgba(72, 158, 133, .12);
  border-radius: 100px;
  padding: 4px 8px;
  font-size: .75rem;
  font-weight: 500;
  margin-top: 11.5px;
}
.account-information{
  display: flex;
  flex-direction: column;
  gap:4px;
}
.payout-account-text{
  display: flex;
  flex-direction: row;
  gap:16px;
}
.payout-account-text2{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap:16px;
  align-items: center;
}
.set-default{
  color: #344054;
  font-size: .875rem;
  font-weight: 500;
  text-decoration: none;
}
.empty-payment{
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 8rem;
  padding-bottom: 6rem;
  display: flex;
  gap: 1rem;
}
.empty-image{
  width: 150px;
  height: 150px;
}
.payment-details2{
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.payment-details{
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.select-country-content{
  padding: 24px;
}
.topup-modal-1{
  height: 360px;
  width: 358px;
}

.tab-content > .active  {
  background: white !important;
}
.add-rate-item-btn:hover{
  color: #489e85
}
.acc__title{
  margin-left: 15px;
  margin-bottom: 6px;

}

.accounts-tab.w-inline-block.w-tab-link{
font-size: 16px;
}
.acc-module-p{
  font-weight: 400 !important;
}
.accounts-tab.w-inline-block.w-tab-link{
  padding: 0;
}
.acc-module-title{
  margin-top: 38px;
}
.acc-form-block{
  grid-row-gap: 30px
}
.textarea-2 {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
}

.rate-card-form-input {
  color: #1d2939;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 6px 14px;
}
.rate-card-form-input.price {
  background-image: url('../../assets/images/dollar.svg');
  background-position: 14px;
  background-repeat: no-repeat;
  background-size: auto;
  padding-left: 30px;
}
.tabs.tabs-menu-5.w-tabs{

}

</style>